import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getTopRanking } from '../utils/firestoreApi';

const RankingContainer = styled.div`
  width: 100%;
  max-width: 600px;
  color: white;
  min-height: calc(100vh - 250px);
  /* overflow-y: auto; */
  display: flex;
  flex-direction: column;
  background: transparent;
  align-items: center;
`;

const RankingTitle = styled.h1`
  text-align: center;
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: white;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.5);
`;

const RankingTable = styled.div`
  background: rgba(255, 255, 255, 0.1); /* 반투명 배경은 유지 */
  border-radius: 15px;
  padding: 20px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  flex: 1;
  min-height: 400px; /* 최소 높이 유지 */
  max-height: calc(100vh - 350px); /* 하단 버튼+상단 여백만큼 빼기, 필요시 값 조정 */
  overflow-y: auto;
  max-width: 95%;
  position: relative; /* 내부 고정 요소를 위한 상대 위치 */
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
  
  @media (max-width: 400px) {
    min-height: 100px;
    max-height: 450px;
    padding: 6px 2px;
    font-size: 0.85rem;
  }
`;

const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.2fr 1fr;
  gap: 10px;
  padding: 15px 10px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 0.9rem;
  
  > div {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  > div:first-child {
    min-width: 50px;
  }
`;

const TableRow = styled.div`
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.2fr 1fr;
  gap: 10px;
  padding: 12px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  align-items: center;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 8px;
  }
`;

const Rank = styled.div`
  font-weight: bold;
  text-align: center;
  font-size: 1.1rem;
  min-width: 50px;
  
  ${props => props.$top3 && `
    color: ${props.$rank === 1 ? '#FFD700' : props.$rank === 2 ? '#C0C0C0' : '#CD7F32'};
    font-size: 1.3rem;
  `}
`;

const Email = styled.div`
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Score = styled.div`
  text-align: center;
  font-weight: bold;
  color: #FFD700;
`;

const Combo = styled.div`
  text-align: center;
  font-weight: bold;
  color: #FF6B6B;
`;

// 본인 랭킹 스타일 컴포넌트
const UserRankingRow = styled.div`
  position: sticky;
  bottom: 0;
  background: rgb(61, 61, 61);
  border: 2px solid #FFD700;
  border-radius: 10px;
  margin-top: 10px;
  padding: 12px 10px;
  display: grid;
  grid-template-columns: 0.5fr 3fr 1.2fr 1fr;
  gap: 10px;
  align-items: center;
  z-index: 10;
  min-height: 30px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.3);
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
  justify-content: center;
  margin-top: 20px;
  flex-shrink: 0;
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  
  ${props => props.$primary ? `
    background: linear-gradient(45deg, #FF6B6B, #FF8E8E);
    color: white;
    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.4);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(255, 107, 107, 0.6);
    }
  ` : `
    background: rgba(255, 255, 255, 0.2);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    
    &:hover {
      background: rgba(255, 255, 255, 0.3);
      transform: translateY(-2px);
    }
  `}
`;

// 목업 데이터 (개발/로컬 테스트용)
/*
const mockRankingData = [
  {
    id: 1,
    nickname: "player1",
    score: 9850,
    combo: 156
  },
  {
    id: 2,
    nickname: "rhythm_master",
    score: 9720,
    combo: 142
  },
  {
    id: 3,
    nickname: "purple_kiss_fan",
    score: 9580,
    combo: 138
  },
  {
    id: 4,
    nickname: "gamer123",
    score: 9450,
    combo: 125
  },
  {
    id: 5,
    nickname: "music_lover",
    score: 9320,
    combo: 118
  },
  {
    id: 6,
    nickname: "rhythm_pro",
    score: 9180,
    combo: 112
  },
  {
    id: 7,
    nickname: "purple_fan",
    score: 9050,
    combo: 108
  },
  {
    id: 8,
    nickname: "game_master",
    score: 8920,
    combo: 95
  },
  {
    id: 9,
    nickname: "music_enthusiast",
    score: 8780,
    combo: 89
  },
  {
    id: 10,
    nickname: "rhythm_champion",
    score: 8650,
    combo: 82
  }
];
*/

function Ranking({ onBack, onRetry, userInfo }) {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userRanking, setUserRanking] = useState(null); // 본인 랭킹 정보

  useEffect(() => {
    setLoading(true);
    getTopRanking()
      .then(data => {
        //console.log('Firestore 랭킹 데이터:', data); // 추가!
        setRanking(data);
        
        // 본인 랭킹 찾기
        if (userInfo && userInfo.phone) {
          const userRank = data.find(player => 
            player.phone === userInfo.phone
          );
          if (userRank) {
            // 랭킹 순위 계산
            const userRankIndex = data.findIndex(player => 
              player.phone === userInfo.phone
            );
            setUserRanking({
              ...userRank,
              rank: userRankIndex + 1
            });
          }
        }
        
        setLoading(false);
      })
      .catch(err => {
        //console.log('Firestore err:', err); // 추가!
        setError('랭킹 데이터를 불러오지 못했습니다.');
        setLoading(false);
      });
  }, [userInfo]);

  return (
    <RankingContainer>
      <RankingTitle>🏆 PURPLE K!SS 랭킹</RankingTitle>
      <RankingTable>
        <TableHeader>
          <div>순위</div>
          <div>닉네임</div>
          <div>점수</div>
          <div>콤보</div>
        </TableHeader>
        {loading && <div style={{textAlign: 'center', padding: '20px'}}>불러오는 중...</div>}
        {error && <div style={{color: 'red', textAlign: 'center'}}>{error}</div>}
        {!loading && !error && ranking.slice(0, 20).map((player, index) => (
          <TableRow key={player.nickname + player.phone + (player.submittedAt?.seconds || index)}>
            <Rank $top3={index < 3} $rank={index + 1}>
              {index + 1}
            </Rank>
            <Email title={player.nickname}>{player.nickname || '-'}</Email>
            <Score>{player.score?.toLocaleString?.() ?? '-'}</Score>
            <Combo>{player.maxCombo ?? '-'}</Combo>
          </TableRow>
        ))}
        
        {/* 본인 랭킹을 테이블 내부 하단에 고정 */}
        {userRanking && (
          <UserRankingRow>
            <Rank $top3={userRanking.rank <= 3} $rank={userRanking.rank}>
              {userRanking.rank}
            </Rank>
            <Email title={userRanking.nickname}>{userRanking.nickname || '-'}</Email>
            <Score>{userRanking.score?.toLocaleString?.() ?? '-'}</Score>
            <Combo>{userRanking.maxCombo ?? '-'}</Combo>
          </UserRankingRow>
        )}
      </RankingTable>
      
      <ButtonContainer>
        <Button onClick={onRetry}>도전하기</Button>
        <Button $primary onClick={onBack}>돌아가기</Button>
      </ButtonContainer>
    </RankingContainer>
  );
}

export default Ranking; 